(function($, KIMPO_DO){
	let storeId = KIMPO_DO.va.pathname.split('/')[3].replace(/\.html/, '');

	// ＜共通＞電話番号リンク
	const setTel = () => {
		$('.js-tel').each((idx, ele) => {
			let telFull = `tel:${$(ele).find('.rt_cf_s_tel_1').text()}${$(ele).find('.rt_cf_s_tel_2').text()}`;
			$(ele).attr('href', telFull);
		});
	};
	// ＜共通＞定休日処理
	const setHoliday = () => {
		const getJSONCurrentTime = () => {
			// ランダム値作成
			const len = 14;
			let str = 'abcdefghijklmnopqrstuvwxyz';
			let strLen = str.length;
			let r = '';
			for (let i = 0; i < len; i++) {
				r += str[Math.floor(Math.random() * strLen)];
			}
			return $.getJSON(`/kimpo-do/ajax/currenttime.json?var=${r}`);
		};
		const getJSONMpsical = (_storeId) => {
			return $.getJSON(`/kimpo-do/ajax/store/mpsical/${_storeId}.json`);
		};
		const getJSONKaisou = (_storeId) => {
			return $.getJSON(`/kimpo-do/ajax/store/kaisou/${_storeId}.json`);
		};
		const adjustTime = (_time) => {
			// 4桁の半角数字でなければ空を返す
			const regex = new RegExp(/^[0-9]{4}$/);
			if (regex.test(_time)) {
				const hour = _time.slice(0, -2);
				const minute = _time.slice(-2);
				return `${hour}:${minute}`;
			} else {
				return '';
			}
		};
		const getNext = (_year, _month) => {
			if (_month + 1 > 12) {
				_month = 1;
				_year += 1;
			} else {
				_month += 1;
			}
			return ([_year, _month]);
		};
		const setCalendarArr = (_data, _year, _month) => {
			let arr = {};
			_month = ('0' + _month).slice(-2);
			arr[`${_year}-${_month}-01`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_1)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_1)}`
			};
			arr[`${_year}-${_month}-02`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_2)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_2)}`
			};
			arr[`${_year}-${_month}-03`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_3)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_3)}`
			};
			arr[`${_year}-${_month}-04`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_4)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_4)}`
			};
			arr[`${_year}-${_month}-05`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_5)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_5)}`
			};
			arr[`${_year}-${_month}-06`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_6)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_6)}`
			};
			arr[`${_year}-${_month}-07`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_7)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_7)}`
			};
			arr[`${_year}-${_month}-08`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_8)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_8)}`
			};
			arr[`${_year}-${_month}-09`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_9)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_9)}`
			};
			arr[`${_year}-${_month}-10`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_10)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_10)}`
			};
			arr[`${_year}-${_month}-11`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_11)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_11)}`
			};
			arr[`${_year}-${_month}-12`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_12)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_12)}`
			};
			arr[`${_year}-${_month}-13`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_13)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_13)}`
			};
			arr[`${_year}-${_month}-14`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_14)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_14)}`
			};
			arr[`${_year}-${_month}-15`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_15)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_15)}`
			};
			arr[`${_year}-${_month}-16`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_16)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_16)}`
			};
			arr[`${_year}-${_month}-17`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_17)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_17)}`
			};
			arr[`${_year}-${_month}-18`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_18)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_18)}`
			};
			arr[`${_year}-${_month}-19`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_19)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_19)}`
			};
			arr[`${_year}-${_month}-20`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_20)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_20)}`
			};
			arr[`${_year}-${_month}-21`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_21)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_21)}`
			};
			arr[`${_year}-${_month}-22`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_22)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_22)}`
			};
			arr[`${_year}-${_month}-23`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_23)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_23)}`
			};
			arr[`${_year}-${_month}-24`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_24)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_24)}`
			};
			arr[`${_year}-${_month}-25`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_25)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_25)}`
			};
			arr[`${_year}-${_month}-26`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_26)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_26)}`
			};
			arr[`${_year}-${_month}-27`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_27)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_27)}`
			};
			arr[`${_year}-${_month}-28`] = {
				mpsicalStart: `${adjustTime(_data.cf_m_start_28)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_end_28)}`
			};
			if (('0' + (new Date(`${_year}-${_month}-29`).getMonth() + 1)).slice(-2) === _month) {
				arr[`${_year}-${_month}-29`] = {
					mpsicalStart: `${adjustTime(_data.cf_m_start_29)}`,
					mpsicalEnd: `${adjustTime(_data.cf_m_end_29)}`
				};
			}
			if (('0' + (new Date(`${_year}-${_month}-30`).getMonth() + 1)).slice(-2) === _month) {
				arr[`${_year}-${_month}-30`] = {
					mpsicalStart: `${adjustTime(_data.cf_m_start_30)}`,
					mpsicalEnd: `${adjustTime(_data.cf_m_end_30)}`
				};
			}
			if (('0' + (new Date(`${_year}-${_month}-31`).getMonth() + 1)).slice(-2) === _month) {
				arr[`${_year}-${_month}-31`] = {
					mpsicalStart: `${adjustTime(_data.cf_m_start_31)}`,
					mpsicalEnd: `${adjustTime(_data.cf_m_end_31)}`
				};
			}
			arr['basic'] = {
				mpsicalStart: `${adjustTime(_data.cf_m_basic_start)}`,
				mpsicalEnd: `${adjustTime(_data.cf_m_basic_end)}`
			};
			return arr;
		};
		const setHolidayDetail = (_storeId) => {
			// 営業時間取得
			getJSONMpsical(_storeId).then((mpsicalData) => {
				if (mpsicalData.rt_bn_mpsical.length) {
					let calendarArr1 = {}, calendarArr2 = {};

					// 当月取得
					let thisDate = new Date(mpsicalData.rt_bn_mpsical[0].cf_m_date);
					const thisYear = thisDate.getFullYear();
					const thisMonth = thisDate.getMonth() + 1;
					if (mpsicalData.rt_bn_mpsical[0]) {
						calendarArr1 = setCalendarArr(mpsicalData.rt_bn_mpsical[0], thisYear, thisMonth);
					}
					if (mpsicalData.rt_bn_mpsical[1]) {
						calendarArr2 = setCalendarArr(mpsicalData.rt_bn_mpsical[1], getNext(thisYear, thisMonth)[0], getNext(thisYear, thisMonth)[1]);
					}

					// 営業予定変更情報
					getJSONKaisou(_storeId).then((kaisouData) => {
						if (kaisouData.rt_bn_mpsical.length) {
							for (let i = 0; i < kaisouData.rt_bn_mpsical.length; i++) {
								const startD = new Date(kaisouData.rt_bn_mpsical[i].cf_k_start_date);

								if (kaisouData.rt_bn_mpsical[i].cf_k_type === '1') { // 休業
									let endD = new Date(kaisouData.rt_bn_mpsical[i].cf_k_end_date);
									endD = new Date(endD.getFullYear(), endD.getMonth(), endD.getDate());
									let thisD = new Date(startD.getFullYear(), startD.getMonth(), startD.getDate());
									while (thisD <= endD) {
										let thisDStr = `${thisD.getFullYear()}-${('0' + (thisD.getMonth() + 1)).slice(-2)}-${(('0' + (thisD.getDate())).slice(-2))}`;
										if (calendarArr1[thisDStr]) {
											calendarArr1[thisDStr].kaisou = '休業';
										}
										if (calendarArr2[thisDStr]) {
											calendarArr2[thisDStr].kaisou = '休業';
										}
										thisD.setDate(thisD.getDate() + 1);
									}
								}
							}
						}
						// Arr結合
						const calendarArrAll = $.extend({}, calendarArr1, calendarArr2);
						// console.dir(calendarArrAll);

						let holidayHTML = '';
						Object.keys(calendarArrAll).forEach((key) => {
							if ((!calendarArrAll[key].mpsicalStart && !calendarArrAll[key].mpsicalEnd) ||	calendarArrAll[key].kaisou === '休業') {
								let holiday = key.slice(4);
								holiday = holiday.replace(/-/g, '/').replace(/\/0/g, '/').slice(1);
								holidayHTML += `${holiday}、`;
							}
						});
						holidayHTML = holidayHTML.slice(0, -1);
						if (holidayHTML) {
							$('.js-holiday').append(holidayHTML);
							$('.__holiday').removeClass('di_none');
						}
					});
				}
			});
		}
		if (!storeId || storeId === 'index') {
			storeId = '5610'; // 店舗一覧では京橋本店のみ
		}
		setHolidayDetail(storeId);
	};
	// ＜一覧＞googlemapへのリンク作成
	const setMapLink = () => {
		$('.js-shopItemParent').each((idx, ele) => {
			let address = `${encodeURI('金鳳堂')} ${encodeURI($(ele).find('.rt_cf_s_name').text())}`;
			$(ele).find('.js-mapBtn').attr(
				'href',
				`https://www.google.com/maps/search/?api=1&query=${address}`
			);
		});
	};
	// ＜詳細＞退店フラグ(cf_s_tai_closing_flg)と退店日（cf_s_tai_closing_date）が設定されている場合、退店の告知のみを表示
	const pastInfoRemove = () => {
		if ($('.rt_closing_date_within2weeks').length) {
			$('.rt_within2weeks').remove();
		}
		if ($('.rt_bn_mpsical_is_0').length) {
			$('.rt_within2weeks').remove();
		}
		if ($('.rt_closing_date_past').length) {
			$('.rt_past').remove();
		}
	};
	// ＜詳細＞京橋本店のみ予約メッセージ変更
	const reserveInfoChange = () => {

	};

	// ============================================================

	if (!storeId || storeId === 'index') {
		setTel();
		setMapLink();
		setHoliday();
	} else {
		pastInfoRemove();

		if ($('.rt_past').length) {
			setTel();
			setHoliday();

			if (storeId === '5610') {
				$('.js-reserveInfo_3').remove();
				$('.js-reserveInfo_2').removeClass('di_none');
			}
		}
	}

})(window.jQuery, window.KIMPO_DO);